import notificationSound from '@assets/audio/notification.mp3';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { ALARM_SOUNDS_MAP } from '@utils/sounds';

const getInitialAudio = () => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      return localStorage.getItem('selectedSound') || notificationSound;
    }
  } catch (error) {
    // LocalStorage not available (e.g. in tests)
  }
  return notificationSound;
};

const initialState = {
  audio: getInitialAudio(),
};

export const preferencesSlice = createSlice({
  name: 'preferences',
  initialState,
  reducers: {
    setAudio: (state, action: PayloadAction<keyof typeof ALARM_SOUNDS_MAP>) => {
      return { ...state, audio: action.payload };
    },
    reset: () => initialState,
  },
});
